<template>
  <div>
    <FeatureItem
      v-for="(item, index) in getFeatures"
      :dataTest="`${String(index)}-Feature`"
      :key="item.vehicleFeatureId"
      :amount="item.amount"
      :maxValue="item.capacity"
      :price="item.price"
      :featureId="item.vehicleFeatureId"
      class="mr-2"
      :name="item.name"
      :icon="item.svgIconBase64"
      :passengersAmount="passengersAmount"
      @setFeatureAmount="setFeatureAmount"
    />
    <FeatureAnimalsItem
      v-if="isShowAnimalsFeature"
      dataTest="Animals"
      :animalsTransportation="animalsTransportation"
      :rideType="rideType"
      :appConfig="appConfig"
      @setAnimalsTransportation="setAnimalsTransportation"
    />
  </div>
</template>

<script lang="ts">
export default {
  name: 'SFeatures',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import FeatureItem from './FeatureItem.vue';
import FeatureAnimalsItem from './FeatureAnimalsItem';

const props = defineProps({
  currentLang: {
    type: String,
    default: 'en',
  },
  features: {
    type: Array,
    default: () => [],
  },
  animalsTransportation: {
    type: Boolean,
    default: false,
  },
  passengersAmount: {
    type: Number,
    default: null,
  },
  rideType: {
    type: String,
    default: null,
  },
  appConfig: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['setFeatureAmount', 'setAnimalsTransportation']);

const isShowAnimalsFeature = computed(() => {
  if (
    props.appConfig.isNightCardsSupport ||
    !props.appConfig.isAnimalsFeatureShown
  ) {
    return false;
  }
  return true;
});

const getFeatures = computed(() => (props.features as Array<Record<string, any>>).map((feature) => ({
  ...feature,
  name:
    feature.localizedVehicleFeatureName[props.currentLang] ||
    feature.localizedVehicleFeatureName.en ||
    feature.identifier,
})));

function setFeatureAmount(feature: unknown) {
  emit('setFeatureAmount', feature);
}

function setAnimalsTransportation(animalsTransportation: boolean) {
  emit('setAnimalsTransportation', animalsTransportation);
}
</script>

<style lang="scss" scoped>
.features-container {
  padding: 0 15px;

  &--xs {
    flex-direction: column;
  }
}
</style>
